<h2 mat-dialog-title>
  Sélectionner un ensemble fonctionnel standard (provenant de la bibliothèque).
</h2>
<app-list-lib-set
  [actions]="['select', 'search']"
  (select)="close($event)">
</app-list-lib-set>
